import { T11 } from "./SalesPerfSummary/T11";
import { T12_02 } from "./ProductSales/T12_02";
import { T09 } from "./ActualLastYear/T09";
import { T10 } from "./ActualTarget/T10";
import { T19_05 } from "./CustomerGroupGrowth/T19_05";
import { T19_10 } from "./CustomerGroupComparativeMonthly/T19_10";

export const AgentComparativeSalesPerf = {
  "sections": [
    T11,
    T12_02,
    T10,
    T09,
    T19_05,
    T19_10
  ]
}